import { ShaderLib } from '../shaders/ShaderLib';
import THREE from '../utils/threeClassesAdapter';
import { radians } from '../../../helpers/degreesAndRadians';

class GradientBackgroundMaterial extends THREE.ShaderMaterial {
    constructor(parameters) {
        const {
            color0, color1,
            ratio0, ratio1,
            rotate,
            fixChubb,
            aspect
        } = parameters;

        // color0, color1 - colors of any format appropriate for THREE.Color
        // ratio0, ratio1 - relative color positions, the order from the less value to the higher one
        // if ratio1 or ratio2 is less then zero then the corresponding color is ignored
        // rotate - linear gradient orientation, 0 is from the bottom to the top, corresponds to css linear-gradient, by degrees

        const { uniforms, vertexShader, fragmentShader } = ShaderLib.gradientBackground;

        super({
            uniforms: THREE.UniformsUtils.clone(uniforms),
            defines: {
                ALPHA_TEST: false
            },
            side: THREE.FrontSide,
            vertexShader,
            fragmentShader
        });

        this.transparent = false;
        if (color0) this.uniforms.color0.value = new THREE.Color(color0);
        if (color1) this.uniforms.color1.value = new THREE.Color(color1);
        if (ratio0) this.uniforms.ratio0.value = ratio0;
        if (ratio1) this.uniforms.ratio1.value = ratio1;
        if (rotate) this.uniforms.rotate.value = radians(rotate);
        if (aspect) this.uniforms.aspect.value = aspect;
        if (typeof fixChubb !== 'undefined') this.uniforms.fixChubb.value = fixChubb;

        this.needsUpdate = true;
    }

    set resolution(value) {
        this.uniforms.uResolution.value.copy(value);
        this.needsUpdate = true;
    }

    get resolution() {
        return this.uniforms.uResolution.value;
    }

    set progress(value) {
        this.uniforms.progress.value = value;
    }

    get progress() {
        return this.uniforms.progress.value;
    }

    setGradientUniforms(params) {
        const {
            color0, color1, ratio0, ratio1, rotate
        } = params;

        const { uniforms } = this;

        uniforms.color0.value = new THREE.Color(color0 || 0x000000);
        uniforms.color1.value = new THREE.Color(color1 || 0xffffff);

        uniforms.rotate.value = radians(rotate || 0);
        uniforms.ratio0.value = ratio0 || 0;
        uniforms.ratio1.value = ratio1 || 1;
    }
}

export default GradientBackgroundMaterial;
